import { engineComponent, NumberUtils } from "neo-common";
import { ClientHost, Communication, GameEngine, Platforms } from "neo-games";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../../Utils/FrameTimer";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { Paytable } from "../Paytable/Paytable";
import { GameData } from "../Datas/GameData";
import { BetManager } from "../../../Managers/BetManager";
import { BaseController } from "../../../GameComponents/Base/BaseController";
import { GameManager } from "../../../Managers/GameManager";
import { ComponentTypes } from "../../../Components/ComponentTypes";
import { AppContext } from "../../../../Common/AppContext";
import { HtmlController } from "../../../HTMLComponents/HtmlController";
import { DataManager } from "../../../Managers/DataManager";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";
import { ResponsibleDialog1 } from "../Dialogs/ResponsibleDialog1";
import { LimitDialog } from "../Dialogs/LimitDialog";
import { UserControls } from "./UserControls";
import { BaseActions } from "../Actions/BaseActions";
import { BalanceManager } from "../../../Managers/BalanceManager";
import { GameActions } from "../Actions/GameActions";
import { Jackpot } from "../Bonuses/Jackpot";
import { Languages } from "../../../Utils/Languages";
import { BetHigherThanMinDialog } from "../Dialogs/BetHigherThanMinDialog";
import { FreeRoundBonusDialog } from "../Dialogs/FreeRoundBonusDialog";
import { FreeRoundBonusIcon } from "../Dialogs/FreeRoundBonusIcon";

var GameModules = Communication.Game.GameModules;

@engineComponent(ComponentTypes.HtmlElement)
export class BaseUserControls extends UserControls {
    protected _controller: BaseController;

    protected _userControls: HTMLElement;
    protected _userControls_supreme: HTMLElement;
    protected _paytable: Paytable;
    protected _afterWinDelay: FrameTimerEventEmitter;
    protected _autoplayDelay: FrameTimerEventEmitter;

    protected _wasCalclulated: boolean = true;
    protected _unColectedWin: number = 0;
    protected _unColectedWinDelay: FrameTimerEventEmitter;
    protected _machineStopped: boolean = true;

    protected longIntro: boolean = false;

    protected _controlsAfterGambleDelay: FrameTimerEventEmitter;

    constructor() {
        super("base");
    }

    create(node: Element): void {
        super.create(node);

        this.registerActions();

        this._afterWinDelay = CreateFrameTimer("afterWinDelay");
        this._afterWinDelay.on(FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));

        this._autoplayDelay = CreateFrameTimer("autoplayDelay");
        this._autoplayDelay.on(FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));

        this._unColectedWinDelay = CreateFrameTimer("unColectedWinDelay");
        this._unColectedWinDelay.on(FrameTimerEvents.Complete, this.unColectedWinDelay.bind(this));

        this._controlsAfterGambleDelay = CreateFrameTimer("controlsAfterGambleDelay");
        this._controlsAfterGambleDelay.on(FrameTimerEvents.Complete, this.controlsAfterGambleDelay.bind(this));

        this._userControls = document.getElementById("userControls");
        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
    }

    addController(controller: BaseController): void {
        this._controller = controller;
        this._controller.on(BaseController.SpinReceived, this.spinReceived.bind(this));
        this._controller.on(BaseController.MachineStopped, this.machineStopped.bind(this));
        this._controller.on(BaseController.WinCalculationFinished, this.winCalculationFinished.bind(this));
        this._controller.on(BaseController.AllWinsFinished, this.allWinsFinished.bind(this));
        this._controller.on(BaseController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(BaseController.OutroFinished, this.outroFinished.bind(this));
        this._controller.on(BaseController.QuickWinCalculationFinished, this.quickWinCalculationFinished.bind(this));
    }

    registerActions(): void {
        this.actions.registerActions({
            [BaseActions.ActionAutoplay]: false,
            [BaseActions.ActionAutoplayStop]: false,
            [BaseActions.ActionBaseCollect]: false,
            [BaseActions.ActionBetPlus]: false,
            [BaseActions.ActionBetMinus]: false,
            [BaseActions.ActionMaxBet]: false,
            [BaseActions.ActionSpin]: false,
            [BaseActions.ActionSpinStop]: false,
        });
    }

    initReceived(): void {
        this._userControls_supreme = document.getElementById("userControls_supreme");

        super.initReceived();

        this._controller.initReceived();

        this._paytable = new Paytable();
        this._paytable.initialize();

        if (GameManager.gameResponse != null) {
            if (!(FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative")) {
                DataManager.updateGameDataFromModule(
                    GameData.DataTotalWin,
                    GameManager.gameResponse.totalWin.toString(),
                );
            }
        }

        if (this._userControls != null && !ModuleManager.gambleActive()) {
            this._userControls.style.display = "none";
        }
        if (this._userControls != null && ModuleManager.gambleActive()) {
            if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
                this._userControls.classList.add(HtmlController.DisabledClass);
            }
        }

        if (this._userControls_supreme != null && !ModuleManager.gambleActive()) {
            this._userControls_supreme.style.display = "none";
        }

        DataManager.updateDataElements();
    }

    collectReceived(): void {
        FreeRoundBonus.enableUi();
        Platforms.Platforms.roundEnded({
            id: GameManager.gameResponse.roundId,
            win: this._unColectedWin,
            balanceAfter: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)),
        });
        Platforms.Platforms.balanceUpdated({ amount: GameManager.gameResponse.balance.real });

        super.collectReceived();

        this._wasCalclulated = true;
        DataManager.Collectable = true;
        DataManager.updateDataElements();

        this.prepareNewGameRound();

        if (AppContext.gameConfiguration.CollectOnUnCalculatedWin && this._unColectedWin > 0) {
            DataManager.updateDataElement(GameData.DataTotalWin, this._unColectedWin.toString());
            this.changeWinBox(true);
        } else {
            if (!(FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative")) {
                DataManager.updateDataElement(GameData.DataTotalWin, "0");
            }
            this.changeWinBox();
        }
        this._unColectedWinDelay.stop();
        //this._unColectedWinDelay.start(75);
        this._unColectedWin = 0;

        if (FreeRoundBonus.isLastFrb) {
            FreeRoundBonus.endFreeRounds();
            ModuleManager.disableBase();
            return;
        }
    }

    restoreGameRound(collect: boolean = false): void {
        super.collectReceived();
        this.changeWinBox(collect);

        FreeRoundBonus.enableUi();

        DataManager.Collectable = true;

        if (this._unColectedWin == 0) {
            this._controller.resetWinAnimator();
        }
        this.prepareNewGameRound();
    }

    spinReceived(): void {
        FreeRoundBonus.frbSpin();

        let isBonusGame = false;
        if (GameManager.baseResponse.screen.reels !== null && GameManager.baseResponse.screen.reels !== undefined) {
            for (let i: number = 0; i < GameManager.baseResponse.screen.reels.length; i++) {
                if (
                    GameManager.baseResponse.screen.reels[i].transform !== null &&
                    GameManager.baseResponse.screen.reels[i].transform !== undefined
                ) {
                    for (let j: number = 0; j < GameManager.baseResponse.screen.reels[i].transform.length; j++) {
                        if (GameManager.baseResponse.screen.reels[i].transform[j] > 0) {
                            isBonusGame = true;
                        }
                    }
                }
            }
        }

        if (!isBonusGame) {
            if (DataManager.quickspinEnabled()) {
                // auto quick stop
                this.actions.changeActionState(BaseActions.ActionSpinStop, false);
                HtmlController.updateActionElements(this.getAllActions());
                HtmlController.dispatchUiAction("");
                DataManager.updateDataElement(GameData.DataRoundId);
                this._controller.stop();
                return;
            }

            this.actions.changeActionState(
                BaseActions.ActionSpinStop,
                AppContext.gameConfiguration.GameEnableReelsStop,
            );
        }

        HtmlController.updateActionElements(this.getAllActions());
        DataManager.updateDataElement(GameData.DataRoundId);
    }

    dispatchAction(action: string): void {
        if (ModuleManager.gambleActive() || ModuleManager.freespinsActive()) {
            return;
        }

        if (action === GameActions.ActionSpinOrStop) {
            if (this.actions.getActionState(BaseActions.ActionSpin)) {
                action = BaseActions.ActionSpin;
            } else if (this.actions.getActionState(BaseActions.ActionSpinStop)) {
                action = BaseActions.ActionSpinStop;
            } else {
                return;
            }
        }

        if (this.actions.getActionState(action)) {
            if (action === BaseActions.ActionBaseCollect) {
                this.changeWinBox(true);
            } else {
                this.changeWinBox();
            }

            PlayList.play("SND_Click");
            super.dispatchAction(action);

            switch (action) {
                case BaseActions.ActionSpin:
                    this.spin();
                    break;
                case BaseActions.ActionSpinStop:
                    this.stop();
                    break;
                case BaseActions.ActionAutoplay:
                    this.autoplay();
                    break;
                case BaseActions.ActionAutoplayStop:
                    this.autoplayStop();
                    break;
                case BaseActions.ActionMaxBet:
                    this.changeBet(false, true, false);
                    break;
                case BaseActions.ActionBetPlus:
                    this.changeBet(false, false, false);
                    break;
                case BaseActions.ActionBetMinus:
                    this.changeBet(true, false, false);
                    break;
                case BaseActions.ActionBaseCollect:
                    this.collect();
                    break;
            }
        }
    }

    collect(): void {
        if (!this._wasCalclulated) {
            if (GameManager.baseResponse != null && GameManager.baseResponse.currentWin > 0) {
                Platforms.Platforms.win(GameManager.baseResponse.currentWin);
            }
        }

        super.collect();

        ModuleManager.disableGamble();
        this.disable();
        this.playCollectSound();

        this._controller.collect();

        LimitDialog.closeDialog();
        GameManager.collect(GameModules.Base);

        if (!(FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative")) {
            DataManager.updateDataElement(
                GameData.DataTotalWin,
                !AppContext.gameDefinition.Gamble ? "0" : this._unColectedWin.toString(),
            );
        }
        //this._unColectedWinDelay.start(75);
    }

    unColectedWinDelay(): void {
        DataManager.updateDataElement(GameData.DataTotalWin, "0");
    }

    spin(): void {
        this._machineStopped = false;

        FreeRoundBonus.disableUi();
        if (FreeRoundBonus.hasNewActiveOffer()) {
            if (GameManager.gameResponse.totalWin > 0 && !DataManager.GameRoundClosed) {
                this.changeWinBox(true);
                this.collect();
            } else {
                FreeRoundBonus.enableUi();
            }
            return;
        }

        if (this.checkJackpotMiniGame()) {
            return;
        }

        if (
            ResponsibleDialog1.showResponsibleDialog1OnCollect &&
            !(FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative")
        ) {
            if (GameManager.gameResponse.totalWin > 0) {
                this.changeWinBox(true);
                this.collect();
            } else {
                GameManager.canExit();
                this.changeWinBox();
            }

            return;
        }

        if (BetHigherThanMinDialog.canOpenDialog()) {
            if (GameManager.gameResponse.totalWin > 0) {
                this.changeWinBox(true);
                this.collect();
            }
            BetHigherThanMinDialog.openDialog();
            return;
        }

        if (Paytable.shouldOpen(true, true)) {
            if (GameManager.gameResponse.totalWin > 0) {
                this.changeWinBox(true);
                this.collect();
            } else {
                Paytable.show();
            }
            return;
        }

        if (
            !DataManager.Autoplay &&
            !this._wasCalclulated &&
            !DataManager.GameRoundClosed &&
            AppContext.gameConfiguration.CollectOnUnCalculatedWin
        ) {
            this.changeWinBox(true);
            this.collect();
            return;
        } else {
            this.changeWinBox();
            if (!this._wasCalclulated) {
                if (GameManager.baseResponse != null && GameManager.baseResponse.currentWin > 0) {
                    Platforms.Platforms.win(GameManager.baseResponse.currentWin);
                }
            }
        }

        if (GameManager.gameResponse.totalWin > 0 && !DataManager.GameRoundClosed) {
            const balanceTotal = parseFloat(DataManager.getDataById(GameData.DataBalanceTotal));
            const balanceAfter = parseFloat(NumberUtils.add(GameManager.gameResponse.totalWin, balanceTotal));
            Platforms.Platforms.roundEnded({
                id: GameManager.gameResponse.roundId,
                win: GameManager.gameResponse.totalWin,
                balanceAfter: balanceAfter,
                inSpin: true,
            });
        }

        if (!Platforms.Platforms.canSpinOnCollect) {
            this.autoplayStop();
            this.changeWinBox(true);
            this.collect();
            return;
        }

        if (!BalanceManager.hasCredit(false, true)) {
            DataManager.Autoplay = false;
            ModuleManager.disableGamble();
            this.prepareNewGameRound();
            return;
        }

        DataManager.Collectable = false;
        ModuleManager.disableGamble();
        this.actions.disableAllActions();
        if (DataManager.Autoplay) {
            if (
                !DataManager.AutoplayStarted &&
                GameManager.baseResponse != null &&
                GameManager.baseResponse.totalWin != null &&
                GameManager.baseResponse.totalWin > 0
            ) {
                DataManager.updateLossLimit(GameManager.baseResponse.totalWin);
            }
            DataManager.updateLossLimit();
            this.actions.changeActionState(BaseActions.ActionAutoplayStop, DataManager.autoplayEnabled());
        }
        HtmlController.dispatchUiAction("");
        HtmlController.updateActionElements(this.getAllActions());
        this.playCollectSound();

        DataManager.updateTotalGain(true);
        BalanceManager.fixBalance();
        if (!DataManager.GameRoundClosed || (FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative")) {
            DataManager.updateDataElement(GameData.DataTotalWin);
        }
        this._controller.spin();

        LimitDialog.closeDialog();

        this._wasCalclulated = false;

        Platforms.Platforms.roundStarted({
            totalBet: BetManager.Bet,
            freeRound: FreeRoundBonus.inFrb,
            userAction: DataManager.getTrustedUserAction(BaseActions.ActionSpin),
        });
        Platforms.Platforms.spinStarted();
        Platforms.Platforms.balanceUpdated({ amount: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)) });
    }

    stop(): void {
        this.actions.changeActionState(BaseActions.ActionSpinStop, false);
        HtmlController.updateActionElements(this.getAllActions());
        HtmlController.dispatchUiAction("");
        DataManager.quickspinStopped();
        this._controller.stop();
    }

    autoplayDelayed(): void {
        this._autoplayDelay.stop();
        if (DataManager.Autoplay) {
            this.autoplay();
        } else {
            this.prepareNewGameRound();
        }
    }

    autoplay(): void {
        this._afterWinDelay.stop();

        if (this.checkJackpotMiniGame()) {
            return;
        }

        if (DataManager.AutoplayCount === "∞") {
            DataManager.Autoplay = true;
            DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
            this.spin();
        } else {
            DataManager.AutoplayCount = (parseInt(DataManager.AutoplayCount) - 1).toString();
            if (parseInt(DataManager.AutoplayCount) >= 0) {
                DataManager.Autoplay = true;
                DataManager.updateDataElement(GameData.DataAutoplayCount, DataManager.AutoplayCount);
                this.spin();
            } else {
                DataManager.Autoplay = false;
                this.prepareNewGameRound();
            }
        }
    }

    autoplayStop(): void {
        DataManager.Autoplay = false;

        Platforms.Platforms.autoplayStop();

        if (this._machineStopped) {
            if (DataManager.GameRoundClosed) {
                FreeRoundBonus.enableUi();
                Platforms.Platforms.roundEnded();
                if (FreeRoundBonus.isLastFrb) {
                    FreeRoundBonus.endFreeRounds();
                    ModuleManager.disableBase();
                }
            }
        }

        this.actions.changeActionState(BaseActions.ActionAutoplayStop, false);
        HtmlController.updateActionElement(BaseActions.ActionAutoplayStop, false);
    }

    changeBet(decrease: boolean = false, max: boolean = false, cycle: boolean = false): void {
        if (!DataManager.GameRoundClosed) {
            this._unColectedWin = 0;
            DataManager.updateDataElement(GameData.DataTotalWin, "0");
            this.changeWinBox();
            this.collect();
        } else {
            this._controller.collect();
            DataManager.updateDataElement(GameData.DataTotalWin, "0");
            DataManager.updateDataElement(GameData.DataBalanceBonus);
            DataManager.updateDataElement(GameData.DataBalanceReal);
            DataManager.updateDataElement(GameData.DataBalanceTotal);
            LimitDialog.closeDialog();
        }
        BetManager.changeBet(decrease, max, cycle);
        this._paytable.updateDataValues();

        if (BetManager.minBet) {
            this.actions.changeActionState(BaseActions.ActionBetMinus, false);
            HtmlController.updateActionElement(BaseActions.ActionBetMinus, false);
            this.actions.changeActionState(BaseActions.ActionBetPlus, true);
            HtmlController.updateActionElement(BaseActions.ActionBetPlus, true);
        } else if (BetManager.maxBet) {
            this.actions.changeActionState(BaseActions.ActionBetPlus, false);
            HtmlController.updateActionElement(BaseActions.ActionBetPlus, false);
            this.actions.changeActionState(BaseActions.ActionBetMinus, true);
            HtmlController.updateActionElement(BaseActions.ActionBetMinus, true);
        } else {
            this.actions.changeActionState(BaseActions.ActionBetPlus, true);
            HtmlController.updateActionElement(BaseActions.ActionBetPlus, true);
            this.actions.changeActionState(BaseActions.ActionBetMinus, true);
            HtmlController.updateActionElement(BaseActions.ActionBetMinus, true);
        }

        if (AppContext.gameConfiguration.ShowMaxBetMessage && max) {
            const message = AppContext.gameConfiguration.MaxButton
                ? Languages.getRid("MAX_BET_MESSAGE_PL")
                : Languages.getRid("MAX_BET_MESSAGE");
            GameManager.openConfirmationDialog(Communication.Game.GameModules.Base, message);
        }
    }

    machineStopped(isHighWin: boolean): void {
        this._machineStopped = true;
        Platforms.Platforms.spinEnded();

        DataManager.stopAutoplayIfLossLimit();
        DataManager.stopAutoplayIfWinLimit();

        if (DataManager.GameRoundClosed && GameManager.baseResponse.totalWin === 0) {
            FreeRoundBonus.enableUi();
            Platforms.Platforms.roundEnded({
                id: GameManager.gameResponse.roundId,
                win: GameManager.gameResponse.totalWin,
                balanceAfter: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)),
            });
            if (FreeRoundBonus.isLastFrb) {
                FreeRoundBonus.endFreeRounds();
                ModuleManager.disableBase();
                return;
            }
        }

        this._unColectedWinDelay.stop();
        this._unColectedWin = GameManager.gameResponse.totalWin;

        if (ModuleManager.gambleActive()) {
            this.disable();
            return;
        }

        if (ModuleManager.freespinsEnabled()) {
            FreeRoundBonus.disableUi();
            this.disable();
            return;
        }

        if (DataManager.Autoplay) {
            if (DataManager.AutoplayCount === 0 + "") {
                DataManager.Autoplay = false;
            }
        }

        if (GameManager.baseResponse.totalWin === 0) {
            this._wasCalclulated = true;
            DataManager.Collectable = true;
        } else {
            this._wasCalclulated = false;
        }

        ModuleManager.enableGamble();
        this.actions.changeActionState(BaseActions.ActionSpinStop, false);
        this._afterWinDelay.stop();
        if (isHighWin) {
            this._afterWinDelay.start(95);
        } else {
            if (GameManager.baseResponse.totalWin > 0) {
                this._afterWinDelay.start(35);
            } else {
                this.prepareNewGameRound();
            }
        }

        HtmlController.updateActionElements(this.getAllActions());

        if (DataManager.Autoplay && GameManager.baseResponse.totalWin === 0) {
            this._autoplayDelay.start(15);
        }

        if (DataManager.GameRoundClosed && GameManager.baseResponse.totalWin > 0) {
            if (FreeRoundBonus.isLastFrb) {
                this.disableAllActions();
                return;
            }
        }

        // Collect total win in last cumulative FRB round when GR isn't yet closed and there isn't current win
        if (FreeRoundBonus.isLastFrb && FreeRoundBonus.winPayMethod === "cumulative") {
            if (
                !DataManager.GameRoundClosed &&
                GameManager.baseResponse.totalWin > 0 &&
                GameManager.baseResponse.currentWin === 0
            ) {
                this._controller.resetWinAnimator();
                this.collect();
                return;
            }
        }
        //  Try to show RCI dialog by canExit() call when in FRB Cumulative and GameRound is closed
        if (FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative") {
            if (DataManager.GameRoundClosed) {
                GameManager.canExit();
            }
        }
    }

    quickWinCalculationFinished(): void {
        if (GameManager.baseResponse != null && GameManager.baseResponse.currentWin > 0 && !this._wasCalclulated) {
            Platforms.Platforms.win(GameManager.baseResponse.currentWin);
        }

        this._wasCalclulated = true;
        DataManager.updateDataElement(GameData.DataTotalWin);
    }

    winCalculationFinished(): void {
        if (DataManager.GameRoundClosed) {
            Platforms.Platforms.roundEnded({
                id: GameManager.gameResponse.roundId,
                win: GameManager.gameResponse.totalWin,
                balanceAfter: parseFloat(DataManager.getDataById(GameData.DataBalanceTotal)),
            });
        }

        if (ModuleManager.gambleActive()) {
            this.disable();
            return;
        }

        if (ModuleManager.freespinsEnabled()) {
            DataManager.updateDataElement(GameData.DataTotalWin);
            return;
        }

        this._afterWinDelay.stop();

        DataManager.updateDataElement(GameData.DataTotalWin);
        if (DataManager.GameRoundClosed && !(FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative")) {
            DataManager.updateDataElements();
        }
        ModuleManager.enableGamble();
        DataManager.Collectable = true;
        this.prepareNewGameRound();

        if (DataManager.GameRoundClosed && GameManager.baseResponse.totalWin > 0) {
            if (!ModuleManager.gambleEnabled()) {
                FreeRoundBonus.enableUi();
            }
            if (FreeRoundBonus.isLastFrb) {
                this.disableAllActions();
                return;
            }
        } else {
            FreeRoundBonus.enableFrbExpiration();
        }
    }

    allWinsFinished(): void {
        FreeRoundBonus.enableFrbExpiration();

        if (GameManager.baseResponse != null && GameManager.baseResponse.currentWin > 0 && !this._wasCalclulated) {
            Platforms.Platforms.win(GameManager.baseResponse.currentWin);
        }

        this._wasCalclulated = true;

        if (ModuleManager.gambleActive()) {
            this.disable();
            return;
        }

        if (ModuleManager.freespinsEnabled()) {
            ModuleManager.enableFreespins();
            this._controller.startConfigurator();
            return;
        }

        this._afterWinDelay.stop();
        this.prepareNewGameRound();
        ModuleManager.enableGamble();
        if (DataManager.Autoplay && this.actions.getActionState(BaseActions.ActionAutoplayStop)) {
            this.autoplay();
        }

        if (DataManager.GameRoundClosed && GameManager.baseResponse.totalWin > 0) {
            if (FreeRoundBonus.isLastFrb) {
                this._controller.resetWinAnimator();
                FreeRoundBonus.endFreeRounds();
                ModuleManager.disableBase();
                return;
            }
        }

        if (FreeRoundBonus.isLastFrb && FreeRoundBonus.winPayMethod === "cumulative") {
            if (!DataManager.GameRoundClosed && GameManager.baseResponse.totalWin > 0) {
                this._controller.resetWinAnimator();
                this.collect();
                return;
            }
        }
    }

    initIntro(): void {
        super.initIntro();
        this._controller.initIntro();
        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }

        if (ModuleManager.freespinsEnabled()) {
            ModuleManager.enableFreespins();
            return;
        }

        this.prepareNewGameRound();
        ModuleManager.enableGamble();
        this._unColectedWin = GameManager.gameResponse.totalWin;

        if (FreeRoundBonus.isLastFrb && FreeRoundBonus.winPayMethod === "cumulative") {
            if (DataManager.GameRoundClosed) {
                FreeRoundBonus.endFreeRounds();
                ModuleManager.disableBase();
            }
            return;
        }
    }

    intro(long: boolean = false): void {
        this._wasCalclulated = true;

        this._unColectedWin = GameManager.gameResponse.totalWin;

        if (DataManager.GameRoundClosed) {
            Platforms.Platforms.roundEnded();
        }

        this.longIntro = long;

        if (DataManager.GameRoundClosed) {
            DataManager.updateDataElement(GameData.DataBalanceBonus);
            DataManager.updateDataElement(GameData.DataBalanceReal);
            DataManager.updateDataElement(GameData.DataBalanceTotal);
        }

        this._controller.intro(long);
        if (this._userControls != null) {
            this._userControls.style.display = "block";
        }

        if (this._userControls_supreme != null) {
            this._userControls_supreme.style.display = "block";
        }
    }

    introFinished(): void {
        if (DataManager.GameRoundClosed) {
            Platforms.Platforms.roundEnded();
        }
        if (!ResponsibleDialog1.opened) {
            DataManager.Autoplay = DataManager.AutoplayAfterGamble;
        }
        ModuleManager.enableGamble();
        this.prepareNewGameRound();
        if (DataManager.Autoplay) {
            this._autoplayDelay.start(60);
        }

        this._controlsAfterGambleDelay.start(0);

        if (
            this.longIntro &&
            DataManager.GameRoundClosed &&
            (FreeRoundBonus.id != null || FreeRoundBonus.otherOfferes.length > 0)
        ) {
            FreeRoundBonus.enableUi();
            this.longIntro = false;
        }

        if (FreeRoundBonus.isLastFrb && DataManager.GameRoundClosed) {
            FreeRoundBonus.endFreeRounds();
            ModuleManager.disableBase();
            return;
        }
    }

    controlsAfterGambleDelay() {
        if (this._userControls != null && this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.remove(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.remove(HtmlController.DisabledClass);
        }
    }

    outro(): void {
        if (!this._wasCalclulated) {
            if (GameManager.gameResponse != null && GameManager.gameResponse.totalWin > 0) {
                Platforms.Platforms.win(GameManager.gameResponse.totalWin);
            }
        }

        this._afterWinDelay.stop();
        this._autoplayDelay.stop();
        DataManager.AutoplayAfterGamble = DataManager.Autoplay;
        DataManager.Autoplay = false;
        if (ModuleManager.freespinsActive()) {
            DataManager.AutoplayAfterGamble = false;
            if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
                this._userControls.classList.add(HtmlController.DisabledClass);
            }

            if (
                this._userControls_supreme != null &&
                !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
            ) {
                this._userControls_supreme.classList.add(HtmlController.DisabledClass);
            }
        }

        this._controller.outro();
    }

    outroFinished(): void {
        if (this._userControls != null) {
            this._userControls.style.display = "none";
        }
        ModuleManager.introModule(GameModules.Gamble);
    }

    prepareNewGameRound(): void {
        this._afterWinDelay.stop();

        if (this.prepareJackpotMiniGame()) {
            return;
        }

        if (ResponsibleDialog1.opened) {
            return;
        }

        BetHigherThanMinDialog.openDialog();
        Paytable.openAtStart(true);

        if (BetHigherThanMinDialog.canOpenDialog() && FreeRoundBonusDialog.dialogActive()) {
            return;
        }

        if (DataManager.GameLimit) {
            DataManager.Autoplay = false;
            this.limit();
        } else {
            if (!DataManager.Autoplay) {
                this.actions.changeActionStates({
                    [BaseActions.ActionAutoplay]:
                        (DataManager.GameRoundClosed ||
                            (FreeRoundBonus.inFrb &&
                                FreeRoundBonus.winPayMethod === "cumulative" &&
                                !FreeRoundBonus.isLastFrb)) &&
                        DataManager.autoplayEnabled(),
                    [BaseActions.ActionAutoplayStop]: false,
                    [BaseActions.ActionBaseCollect]:
                        FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod === "cumulative"
                            ? false
                            : !DataManager.GameRoundClosed,
                    [BaseActions.ActionBetPlus]: !BetManager.maxBet,
                    [BaseActions.ActionBetMinus]: !BetManager.minBet,
                    [BaseActions.ActionMaxBet]:
                        !ModuleManager.gambleEnabled() &&
                        !FreeRoundBonus.inFrb &&
                        AppContext.gameConfiguration.MaxBetEnabled,
                    [BaseActions.ActionSpin]: !FreeRoundBonus.isLastFrb,
                    [BaseActions.ActionSpinStop]: false,
                });

                if (DataManager.GameRoundClosed) {
                    Platforms.Platforms.roundInit();
                }
            }
        }

        HtmlController.updateActionElements(this.getAllActions());
    }

    protected prepareJackpotMiniGame(): boolean {
        if (DataManager.GameRoundClosed && Jackpot.hasMiniGame() && !FreeRoundBonus.inFrb) {
            if (Jackpot.hasInitializedGame() && this._wasCalclulated) {
                DataManager.Autoplay = false;
                this.resetWinAnimator();
                this.disable();
                FreeRoundBonus.disableUi();
                Jackpot.startMiniGame();

                return true;
            } else {
                const self = this;

                //in nogamble we need to wait for winCalculated finish to not run minigame right after machinestopped
                if (this._wasCalclulated) {
                    Jackpot.initMiniGame(true, () => {
                        self.resetWinAnimator();
                        self.disable();
                        DataManager.Autoplay = false;
                        FreeRoundBonus.disableUi();
                    });
                }

                //in case we have nogamble and pb within or after gr, check limit
                if (DataManager.GameLimit) {
                    DataManager.Autoplay = false;
                    this.limit();
                }

                if (Jackpot.waitForMiniGameInitialization()) {
                    //in case we have limit, disable all actions during animation and wait for minigame
                    this.actions.disableAllActions();
                    HtmlController.updateActionElements(this.getAllActions());

                    return true;
                }
            }
        }
        return false;
    }

    protected checkJackpotMiniGame(): boolean {
        if (!Jackpot.hasMiniGame() || FreeRoundBonus.inFrb) {
            return false;
        }

        if (Jackpot.hasInitializedGame() || Jackpot.waitForMiniGameInitialization()) {
            if (GameManager.gameResponse.totalWin > 0) {
                this.changeWinBox();
                this._wasCalclulated = true;

                if (!DataManager.GameRoundClosed) {
                    this.collect(); //collect will call prepareNewGameRound
                } else {
                    //in nogamble gameround is closed, we need to update balance, if we have totalwin > 0
                    this.playCollectSound();
                    DataManager.updateDataElements();
                    this.prepareNewGameRound();
                }
            } else {
                this.prepareNewGameRound();
            }

            return true;
        } else {
            Jackpot.initMiniGame(false, null);
            Jackpot.disableMiniGameAutostart(); //if init was called from preparenewgameround

            return false;
        }
    }

    limit(): void {
        LimitDialog.openDialog();

        if (DataManager.GameRoundClosed) {
            this.actions.changeActionStates({
                [BaseActions.ActionAutoplay]: DataManager.autoplayEnabled(),
                [BaseActions.ActionAutoplayStop]: false,
                [BaseActions.ActionBaseCollect]: false,
                [BaseActions.ActionBetPlus]: !BetManager.maxBet,
                [BaseActions.ActionBetMinus]: !BetManager.minBet,
                [BaseActions.ActionMaxBet]: !FreeRoundBonus.inFrb && AppContext.gameConfiguration.MaxBetEnabled,
                [BaseActions.ActionSpin]: true,
                [BaseActions.ActionSpinStop]: false,
            });
        } else {
            this.actions.changeActionStates({
                [BaseActions.ActionAutoplay]: false,
                [BaseActions.ActionAutoplayStop]: false,
                [BaseActions.ActionBaseCollect]: true,
                [BaseActions.ActionBetPlus]: false,
                [BaseActions.ActionBetMinus]: false,
                [BaseActions.ActionMaxBet]: false,
                [BaseActions.ActionSpin]: false,
                [BaseActions.ActionSpinStop]: false,
            });
        }
    }

    disable(): void {
        this._afterWinDelay.stop();
        this.actions.disableAllActions();
        FreeRoundBonusIcon.disableActiveIcon();
        HtmlController.updateActionElements(this.getAllActions());

        this._controller.disableBase();
    }

    //disable base without reseting timer and win animations in winAnimator
    //used in frb, to avoid not showing end message in last frb spin with win
    protected disableAllActions(): void {
        this._afterWinDelay.stop();
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());
    }

    disableAndHide(): void {
        this._afterWinDelay.stop();
        this.actions.disableAllActions();
        HtmlController.updateActionElements(this.getAllActions());

        if (this._userControls != null && !this._userControls.classList.contains(HtmlController.DisabledClass)) {
            this._userControls.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._userControls_supreme != null &&
            !this._userControls_supreme.classList.contains(HtmlController.DisabledClass)
        ) {
            this._userControls_supreme.classList.add(HtmlController.DisabledClass);
        }
    }

    resetWinAnimator(): void {
        this._controller.resetWinAnimator();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/UserControls/BaseUserControls.ts
 **/